type NumberFormatOptions = {
    decimals?: number,
    decimalSeparator?: string,
    thousandsSeparator?: string,
};

function numberFormat(
    num: number,
    { decimals = 0, decimalSeparator = '.', thousandsSeparator = ' ' }: NumberFormatOptions = {},
): string {
    const numString = num.toFixed(decimals).toString();
    let [intString, fractionString] = numString.split('.');

    while (intString.match(/([0-9])([0-9]{3})(\s[0-9]{3})*$/) !== null) {
        intString = intString.replace(/([0-9])([0-9]{3})(\s[0-9]{3})*$/, '$1' + thousandsSeparator + '$2$3');
    }

    return fractionString !== undefined
        ? `${intString}${decimalSeparator}${fractionString}`
        : intString;
}

function formatFileSize(size: number): string {
    if (size < 1024) {
        return size + ' Байт';
    }

    const sizeKb = size / 1024;
    if (sizeKb < 1024) {
        return sizeKb.toFixed(1) + ' Кб';
    }

    const sizeMb = sizeKb / 1024;
    if (sizeMb < 1024) {
        return sizeMb.toFixed(1) + ' Мб';
    }

    return (sizeKb / 1024).toFixed(1) + ' Гб';
}

function choice(num: number, single: string, little: string, many: string): string {
    const last2 = num % 100;

    if (last2 > 4 && last2 < 21) {
        return many;
    }

    const last = num % 10;

    if (last === 1) {
        return single;
    }

    if (last < 5) {
        return little;
    }

    return many;
}

export {
    numberFormat,
    formatFileSize,
    choice,
};
